// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import type { GenderReachData } from 'common/domain/GenderReach';
import LoadingSpinner from 'common/components/LoadingSpinner';
import { Percent } from '../../components/Number';
import GenderPieChart from './GenderPieChart';


const Wrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const HorizontalCardWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
`;

const VerticalCardWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const CardLeft = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-end;
`;

const CardRight = styled(CardLeft)`
  align-items: flex-start;
`;

const VerticalGenderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  font-size: 1.5rem;
`;

const HorizontalGenderWrapper = styled.div`
  width: 100%;
  font-size: ${({ fontSize }) => (`${fontSize}px` || '1.2rem')};
`;

type LegendPosition = 'around' | 'bottom';

type Props = {
  data: GenderReachData;
  errorStyle?: Object;
  isLoading?: boolean;
  legendPosition?: LegendPosition;
  animate?: boolean;
  fontSize?: number;

  theme: Object;
  t: any;
};

type State = {
  pieData: Array<Object>;
  malePercent: number;
  femalePercent: number;
};

class GenderGraph extends React.Component<Props, State> {
  static defaultProps = {
    legendPosition: 'around',
    animate: true,
  };

  state = { pieData: [], malePercent: 0, femalePercent: 0 };

  static getDerivedStateFromProps(props, state) {
    const { data, t } = props;
    if (!data) {
      return { pieData: [], malePercent: 0, femalePercent: 0 };
    }
    const total = data.male + data.female;
    const malePercent = data.male / total;
    const femalePercent = data.female / total;

    const pieData = [
      { name: t('gender.men'), value: malePercent, color: 'male' },
      { name: t('gender.women'), value: femalePercent, color: 'female' },
    ];

    return {
      pieData,
      malePercent,
      femalePercent,
    };
  }

  render() {
    const { data, legendPosition, errorStyle, isLoading, t, animate, fontSize } = this.props;
    const { fonts, colors } = this.props.theme;
    const { malePercent, femalePercent, pieData } = this.state;

    return (
      <Wrapper>
        {isLoading &&
        <LoadingSpinner />
        }
        {!data && !isLoading &&
        <span style={{ ...fonts.style.cardTitle, ...errorStyle }}>
            {t('noDataAvailable')}
          </span>
        }
        {data && !isLoading && legendPosition === 'around' &&
        <HorizontalCardWrapper>
          <CardLeft>
            <VerticalGenderWrapper gender="male" style={{ color: colors.male }}>{t('gender.men')} <Percent value={malePercent} /></VerticalGenderWrapper>
          </CardLeft>
          <GenderPieChart pieData={pieData} colors={colors} animate={animate} />
          <CardRight>
            <VerticalGenderWrapper gender="female" style={{ color: colors.female }}>{t('gender.women')} <Percent value={femalePercent} /></VerticalGenderWrapper>
          </CardRight>
        </HorizontalCardWrapper>
        }
        {data && !isLoading && legendPosition === 'bottom' &&
        <VerticalCardWrapper>
          <GenderPieChart pieData={pieData} colors={colors} animate={animate} />
          <div style={{ textAlign: 'center' }}>
            <HorizontalGenderWrapper fontSize={fontSize} style={{ color: colors.male }}>{t('gender.men')} <Percent value={malePercent} /></HorizontalGenderWrapper>
            <HorizontalGenderWrapper fontSize={fontSize} style={{ color: colors.female }}>{t('gender.women')} <Percent value={femalePercent} /></HorizontalGenderWrapper>
          </div>
        </VerticalCardWrapper>
        }
      </Wrapper>
    );
  }
}

export default withTheme(translate()(GenderGraph));



// WEBPACK FOOTER //
// ./src/common/components/charts/GenderGraph.js